// extracted by mini-css-extract-plugin
export default {"container":"FormContent_container__oywli","title":"FormContent_title__0Cg+c","active":"FormContent_active__vtYkp"};